<template>
  <div class="homepage">
    <div class="maf-loading" v-show="isLoading">
      <div class="spinner">
        <svg-icon :name="'lc-logo'" :width="115" :height="114"></svg-icon>
      </div>
    </div>
    <home-header/>
    <custom-popup></custom-popup>
    <div class="content-footer" :class="{ 'is-not-home-content' : !isHome }">
      <div class="content" id="mainPage">
        <side-bar/>
        <phone-menu v-show="showPhoneMenu" />
        <div class="main">
          <div class="grant-btns">
            <maf-button class="button" v-if="isDACAGrantAvailable" :name="dacaGrantBtnText" :width="ifrpBtnWidth" :fontSize="ifrpBtnFont" @actionFunc="showPopup('DACAPreAppGrant')"/>
            <maf-button class="button" v-if="isDACALoanAvailable" :name="dacaLoanBtnText" :width="ifrpBtnWidth" :fontSize="ifrpBtnFont" :bgColor="'-webkit-linear-gradient(left top, #3023AE, #C86DD7)'" @actionFunc="showPopup('DACALoan')"/>
            <maf-button class="button" v-if="isIFRPAvailable" :name="ifrpBtnText" :width="ifrpBtnWidth" :fontSize="ifrpBtnFont" @actionFunc="showPopup('IFRP')"/>
            <maf-button class="button" v-if="isIFRPLoanAvailable" :name="ifrpLoanBtnText" :width="ifrpBtnWidth" :fontSize="ifrpBtnFont" @actionFunc="showPopup('IFRP-Loan')"/>
            <maf-button class="button" v-if="isMIJAGrantAvailable" :name="mijaGrantBtnText" :width="ifrpBtnWidth" :fontSize="ifrpBtnFont" @actionFunc="showPopup('Immigration-Grant-OCEIA')"/>
          </div>
          <welcome v-if="isNoApplication && isHome"/>
          <div v-else-if="homeStatus === 'success'">
            <router-view ref="routerCmp" :class="[!isHome ? 'section' : '']" />
          </div>
        </div>
      </div>
      <maf-footer/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getViewLoansRemoting, initializeRedirectUrlRemoting } from '../api'
export default {
  name: 'Home',
  data () {
    return {
      isShowPopup: false,
      homeStatus: null,
    };
  },
  async created() {
    const sourceCode = this.getQueryParam('sourceCode');
    /* if (window.location.search && window.location.search.indexOf('action=login') !== -1) {
      let redirectUrl = this.getQueryParam('redirectUrl');
      let ssoUrl = await getLearnWorldsSSOurlRemoting(redirectUrl);
      if (ssoUrl && ssoUrl.indexOf('http' !== -1)) {
        window.location.href = ssoUrl;
        return;
      }
    } */

    const lpId = this.getQueryParam('lpId');
    const source = this.getQueryParam('source');
    if (lpId || source) {
      try {
        let requestParam = {
          sourceCode: sourceCode,
          lpId: lpId,
          source: source
        };
        let jsonParams = JSON.stringify(requestParam);
        let rawResult = await initializeRedirectUrlRemoting(jsonParams);

        if (rawResult && rawResult.startsWith('SUCCESS')) {
          const redirectUrl = rawResult.substring('SUCCESS'.length).trim().replaceAll('&amp;', '&');

          if (this.isValidUrl(redirectUrl)) {
            const currentPath = window.location.pathname;
            const targetPath = new URL(redirectUrl).pathname;

            if (currentPath !== targetPath) {
              window.location.href = redirectUrl;
              return;
            }
          }
        }
      } catch (e) {
        console.error('Error calling initializeRedirectUrlRemoting:', e);
      }
    }

    this.homeStatus = await this.$store.dispatch('INIT_DASHBOARD_HOME_DATA');
  },
  computed: {
    ...mapState({
      currentTab: state => state.currentTab,
      showPhoneMenu: state => state.showPhoneMenu,
      isNoApplication: state => state.isNoApplication,
      isLoading: state => state.isLoading,
      userInfo: state => state.userInfo,
      isDACAGrantAvailable: state => state.contactInfo.isDACAGrantAvailable,
      dacaGrantBtnText: state => state.dacaGrantBtnText,
      isDACALoanAvailable: state => state.contactInfo.isDACALoanAvailable,
      dacaLoanBtnText: state => state.dacaLoanBtnText,
      isIFRPAvailable: state => state.contactInfo.isIFRPAvailable,
      ifrpBtnText: state => state.ifrpBtnText,
      isIFRPLoanAvailable: state => state.contactInfo.isIFRPLoanAvailable,
      ifrpLoanBtnText: state => state.ifrpLoanBtnText,
      isMIJAGrantAvailable: state => state.contactInfo.isMIJAGrantAvailable,
      mijaGrantBtnText: state => state.mijaGrantBtnText,
      isMobile: state => state.isMobile,
    }),
    ifrpBtnWidth() {
      if (this.isMobile) {
        return 350;
      }
      return 395;
    },
    ifrpBtnFont() {
      if (this.isMobile) {
        return 14;
      }
      return 16;
    },
    isHome() {
      return this.currentTab.label === 'Home';
    }
  },
  methods: {
    async showPopup(btnSource) {
      let loanErrorPopup = { isShow: false };
      if (btnSource === 'DACALoan') {
        loanErrorPopup = await getViewLoansRemoting(this.userInfo.userId);
        console.log(loanErrorPopup)
      }
      if (loanErrorPopup.isShow) {
        this.$store.commit('SHOW_LOANS_POPUP', loanErrorPopup);
      } else {
        this.$store.commit('IS_POPUP_STEP_CHANGED', 2);
        this.$store.commit('IS_BUTTON_SOURCE_CHANGED', btnSource);
      }

      this.$store.commit('IS_CUSTOM_POPUP_CHANGED', true);
    },

    getQueryParam(param) {
      const query = window.location.search.substring(1);
      const vars = query.split('&');
      for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === param) {
          return decodeURIComponent(pair[1]);
        }
      }
      return null;
    },

    isValidUrl(url) {
      try {
        // eslint-disable-next-line no-new
        new URL(url);
        return true;
      } catch (_) {
        return false;
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import './../sass/main.scss';

.homepage {
  width: 100%;
  height: 100%;
  min-width: 320px;
  background-color: $bg-color;
  font-size: $font-size-large;
  line-height: $font-size-larger;

  @keyframes scroll {
    0%{
      transform: rotate(0deg);
    }
    50%{
      transform: rotate(180deg);
    }
    100%{
      transform: rotate(360deg);
    }
  }

  .maf-loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(225deg, #1DE9B6 0%, #1DC4E9 100%);
    z-index: 99999999;

    .spinner {
      position: fixed;
      top: 50%;
      transform: translate(-50%, -50%);
      left: 50%;
    }

    .icon {
      animation: scroll 2s infinite linear;
    }
  }

  .content-footer {
    @include inline-flex-col;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .content {
    padding: $header-height+20px 20px 20px 0;
    flex: 1;
    width: 100%;

    @media screen and (max-width: $max-width-phone) {
      padding: $header-height-phone+20px 10px 20px 10px;
    }

    .main {
      float: left;
      margin-left: 50px;
      width: 1006px;
      max-width: 1006px;
      height: auto;
      border-radius: 7px;

      .grant-btns {
        margin-top: 10px;
        margin-bottom: 20px;
        width: 500px;
        .button {
          margin-bottom: 10px;
        }
      }

      .section {
        background-color: $bg-color-white;
        border-radius: 7px;

        .greet {
          padding: 50px 50px 0px 50px;
          font-size: $font-size-largest-more;
          color: $tab-active;

          @media screen and (max-width: $max-width-phone) {
            padding: 15px 5px 5px 15px;
            font-size: $font-size-larger;
          }
        }
      }

      .section-space {
        margin-bottom: 20px;
      }

      &:after {
        content: '';
        clear: left;
      }

      @media screen and (max-width: 1300px) {
        width: calc(100% - 290px);
      }

      @media screen and (max-width: $max-width-phone) {
        margin-left: 0;
        width: 100%;
      }
    }

    .home-data {
      width: 100%;
      height: 100px;
      background-color: $bg-color-white;
      border-radius: 7px;
    }
  }

  .is-not-home-content .main {
    @media screen and (max-width: $max-width-phone) {
      margin-top: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue